import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "attribute-label" }

interface Props {
  attribute: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'AttributeLabel',
  props: {
    attribute: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, _toDisplayString(_ctx.attribute === '1' ? '試薬' : _ctx.attribute === '2' ? 'バルク' : _ctx.attribute === '9' ? 'その他' : ''), 1))
}
}

})